import { EMAIL_REGEX, GENERAL_FORM_CONSTANTS } from "../../../../constants";
import { FormValidationType, CUSTOM_VALIDATION_TYPES } from "../../../../types";
import { CLAIM_INFORMATION_CONSTANTS } from "../../../constants";

export const formFieldsValidation: FormValidationType = {
  [CLAIM_INFORMATION_CONSTANTS.DATE_OF_LOSS]: {
    required: { value: true },
    [CUSTOM_VALIDATION_TYPES.DATE_IS_NOT_IN_FUTURE]: {
      value: true,
    },
  },
  [CLAIM_INFORMATION_CONSTANTS.CUSTOMER_FIRST_NAME]: {
    required: { value: true },
    maxCharacters: { value: 100 },
  },
  [CLAIM_INFORMATION_CONSTANTS.CUSTOMER_LAST_NAME]: {
    required: { value: true },
    maxCharacters: { value: 100 },
  },
  [CLAIM_INFORMATION_CONSTANTS.INSURER_OR_REPRESENTATIVE_NAME]: {
    required: { value: true },
    maxCharacters: { value: 200 },
  },
  [CLAIM_INFORMATION_CONSTANTS.ADDRESS_LINE_1]: {
    required: { value: true },
    maxCharacters: { value: 200 },
  },
  [CLAIM_INFORMATION_CONSTANTS.ADDRESS_LINE_2]: {
    required: { value: false },
    maxCharacters: { value: 200 },
  },
  [CLAIM_INFORMATION_CONSTANTS.CITY]: {
    required: { value: true },
    maxCharacters: { value: 100 },
  },
  [CLAIM_INFORMATION_CONSTANTS.COUNTRY]: {
    required: { value: true },
  },
  [CLAIM_INFORMATION_CONSTANTS.CUSTOMER_EMAIL]: {
    required: { value: true },
    matchRegExp: {
      value: new RegExp(EMAIL_REGEX),
      message: GENERAL_FORM_CONSTANTS.EMAIL_INVALID_MESSAGE,
    },
    [CUSTOM_VALIDATION_TYPES.REMOVE_WHITE_SPACE]: { value: true },
  },
  [CLAIM_INFORMATION_CONSTANTS.CUSTOMER_PHONE]: {
    required: { value: true },
    [CUSTOM_VALIDATION_TYPES.E164_PHONE_FORMAT]: { value: true },
    maxCharacters: { value: 16 }, // E.164 max is 15 digits + 1 for the + sign
  },
  [CLAIM_INFORMATION_CONSTANTS.INCIDENT_TYPE]: {
    required: { value: true },
  },
  [CLAIM_INFORMATION_CONSTANTS.DESCRIPTION_OF_INCIDENT]: {
    required: { value: true },
    maxCharacters: { value: 2000 },
  },
  [CLAIM_INFORMATION_CONSTANTS.COUNTRY_WHERE_INCIDENT_OCCURRED]: {
    required: { value: true },
    matchRegExp: {
      value:
        /^(Austria|Belgium|Canada|France|Germany|Italy|Spain|Sweden|United Kingdom)$/,
      message:
        "This country is not yet supported by claim intake. Please contact support for assistance.",
    },
  },
  [CLAIM_INFORMATION_CONSTANTS.PRODUCT_PURCHASE_DATE]: {
    required: { value: true },
    [CUSTOM_VALIDATION_TYPES.DATE_IS_NOT_IN_FUTURE]: {
      value: true,
    },
  },
};
